import { subYears } from "date-fns";
import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import CustomDatePicker from "../../../../components/customDatePicker/CustomDatePicker";
import SelectOption from "../../../../components/selectOption/SelectOption";
import TextInput from "../../../../components/textInput/TextInput";
import Label from "../../../../components/label/Label";
import SearchBar from "../../../../components/searchBar/SearchBar";
import FileUpload from "../../../../components/fileUpload/fileUpload";
import { getCustomerIdentityAccounts } from "../../../../store/actions/fault.action";
import MainLoader from "../../../../components/loading/MainLoader";
import { getBillFaults } from "../../../../store/actions/fault.action";
import AlertModal from "../../../../components/alertModal/alertModal";
import axios from "axios";
import { BASE_URL } from "../../../../const/URL";

export enum EInputMode {
  primary,
  light,
}

interface IProps {
  onSubmitBill: (data: IBillComplainsFormInputs) => void;
}

export interface IBillComplainsFormInputs {
  serviceId: string;
  invoiceMonthStart: string;
  invoiceMonthEnd: string;
  remark: string;
  contactMobile: string;
  natureOfBillFault: string;
}

const BillComplaint = (props: IProps) => {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IBillComplainsFormInputs>();

  const [invoiceMonthStart, setInvoiceMonthStart] = useState<Date>(new Date());
  const [invoiceMonthEnd, setInvoiceMonthEnd] = useState<Date>(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isVerrified, setIsVerified] = useState(false);
  const [natureOfFaults, setNatureOfFaults] = useState([]);
  const [ServiceID, setServiceIDValue] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (ServiceID) {
      setValue("serviceId", ServiceID);
    }
  }, [ServiceID, setValue]);

  const handle = (value: string) => {
    if (!value) {
      return;
    }

    setIsLoading(true);
    // Validate User
    getCustomerIdentityAccounts(value)
      .then((response) => {
        setIsVerified(true);
        setServiceIDValue(value);
        // Nature of Fault
        getBillFaults()
          .then((response) => {
            setNatureOfFaults(response);
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      })
      .catch((error) => {
        setIsLoading(false);
        setIsVerified(false);
        setShowAlert(true);
        setError(error?.message || "An unexpected error occurred");
      });
  };

  const handleFileSelect = (file: File | null) => {
    setSelectedFile(file);
  };

  const uploadFile = async (file: File, data: IBillComplainsFormInputs) => {
    const token = localStorage.getItem("enterprise_portal_access_Token");
    const formData = new FormData();

    const serviceId = data.serviceId;

    formData.append("ToEmail", "kadlaksitha@gmail.com");
    formData.append("Subject", `Bill Dispute - ${serviceId}`);
    formData.append("Body", `${data.remark}`);
    formData.append("Attachment", file);

    const response = await axios.post(
      `${BASE_URL}/api/v1/ENTSendEmailAttachments/api/EmailSend/SendEmails`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (!response.data) {
      throw new Error("Failed to upload attachment");
    }
  };

  const onSubmit = async (data: IBillComplainsFormInputs) => {
    try {
      setIsLoading(true);

      // First submit the bill complaint
      await props.onSubmitBill(data);

      // If there's a file, upload it after successful complaint submission
      if (selectedFile) {
        await uploadFile(selectedFile, data);
      }

      setSuccess(true);
    } catch (error) {
      setError(
        error instanceof Error ? error.message : "Failed to submit complaint"
      );
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AlertModal
        show={showAlert}
        variant="error"
        buttons={[
          {
            text: "Ok",
            onClick: () => {
              setShowAlert(false);
            },
            variant: "success",
          },
        ]}
      >
        <label>{error}</label>
      </AlertModal>

      {/* <AlertModal
        show={success}
        variant="success"
        buttons={[
          {
            text: "Ok",
            onClick: () => {
              setSuccess(false);
            },
            variant: "success",
          },
        ]}
      >
        Complaint submitted successfully
      </AlertModal> */}

      <MainLoader show={isLoading} />
      <Row className="justify-content-center mt-2 mb-5">
        <Col className="col-md-5">
          <SearchBar onSearch={handle} placeholder="Account Number" />
        </Col>
      </Row>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="poppins-semibold"
        style={{
          opacity: isVerrified ? 1 : 0.6,
          pointerEvents: isVerrified ? "auto" : "none",
          filter: isVerrified ? "none" : "blur(2px)",
          backgroundColor: isVerrified ? "white" : "#f0f0f0",
          transition: "all 0.3s ease-in-out",
          padding: "15px",
          borderRadius: "8px",
        }}
      >
        <Row className="row-cols-1 row-cols-md-2 gy-3">
          <Col>
            <Controller
              control={control}
              defaultValue={undefined}
              name="natureOfBillFault"
              rules={{ required: true }}
              render={({ field: { onChange } }) => (
                <SelectOption
                  label="Nature of Complaint"
                  onChange={(val: any) => {
                    onChange(val.value);
                  }}
                  required
                  options={natureOfFaults.map((item: any) => ({
                    label: item?.pid,
                    value: item?.pid,
                  }))}
                  placeholder="Select Nature of Complaint"
                  errors={[
                    {
                      isShow: errors.natureOfBillFault?.type === "required",
                      message: "Nature of Complaint is required",
                    },
                  ]}
                />
              )}
            />
          </Col>

          <Col>
            <TextInput
              label="Contact - Mobile"
              color="gray"
              placeholder="07XXXXXXXX"
              mode={EInputMode.light}
              required
              useFormRegister={{
                ...register("contactMobile", {
                  required: true,
                  pattern: /^[0][7][01245678][0-9]{7}$/gm,
                }),
              }}
              type="tel"
              inputMode="numeric"
              maxLength={10}
              errors={[
                {
                  isShow: errors.contactMobile?.type === "required",
                  message: "Technical Contact is required",
                },
                {
                  isShow: errors.contactMobile?.type === "pattern",
                  message:
                    "Contact Number must be 10 digits and start with 07XXXXXXXX",
                },
              ]}
            />
          </Col>
          <Col className="w-100">
            <Label className="label">Dispute Effected Months</Label>
          </Col>
          <Col style={{ display: "flex", flexDirection: "row" }}>
            <Controller
              control={control}
              defaultValue={moment(invoiceMonthStart).format("yyyy-MM")}
              name="invoiceMonthStart"
              rules={{ required: true }}
              render={({ field: { onChange } }) => (
                <CustomDatePicker
                  label="Start"
                  minDate={subYears(new Date(), 1)}
                  maxDate={new Date()}
                  onChange={(value) => {
                    const formattedDate = moment(value).format("yyyy-MM");
                    value && setInvoiceMonthStart(value);
                    onChange(formattedDate);
                  }}
                  showMonthYearPicker
                  required
                  selected={invoiceMonthStart}
                  dateFormat="yyyy-MM"
                  placeholderText="yyyy-mm"
                  selectsStart
                  errors={[
                    {
                      isShow: errors.invoiceMonthStart?.type === "required",
                      message: "Dispute Effected Month Start is required",
                    },
                  ]}
                />
              )}
            />
            <div style={{ width: "10px" }} />
            <Controller
              control={control}
              defaultValue={moment(invoiceMonthEnd).format("yyyy-MM")}
              name="invoiceMonthEnd"
              rules={{ required: true }}
              render={({ field: { onChange } }) => (
                <CustomDatePicker
                  label="End"
                  minDate={invoiceMonthStart}
                  maxDate={new Date()}
                  onChange={(value) => {
                    const formattedDate = moment(value).format("yyyy-MM");
                    value && setInvoiceMonthEnd(value);
                    onChange(formattedDate);
                  }}
                  showMonthYearPicker
                  required
                  selected={invoiceMonthEnd}
                  dateFormat="yyyy-MM"
                  placeholderText="yyyy-mm"
                  selectsEnd
                  errors={[
                    {
                      isShow: errors.invoiceMonthStart?.type === "required",
                      message: "Dispute Effected Month End is required",
                    },
                  ]}
                />
              )}
            />
          </Col>

          <Col className="col-md-12">
            <TextInput
              label="Remark"
              color="gray"
              mode={EInputMode.light}
              placeholder="Brief Description (Should be limit to 80 characters)"
              useFormRegister={{ ...register("remark", { required: false }) }}
              maxLength={80}
            />
          </Col>
          <Col className="col-md-12">
            <FileUpload
              onFileSelect={handleFileSelect}
              maxFiles={1}
              disabled={!isVerrified}
            />
          </Col>
        </Row>

        <Row className="mt-2 mb-3 justify-content-center">
          <Col className="col-md-3">
            <Button type="submit" className="w-100" variant="success">
              Submit
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default BillComplaint;
